export default __webpack_public_path__ + "static/media/johnImage.a161513b.png";